import { Link } from "react-router-dom";
import { Star, Files } from "lucide-react";
import FileBadge from "./FileBadge";
import FavoriteButton from "./FavoriteButton";
import { formatDate } from "../lib/format";

// Card unica: materiale (m) oppure raccolta (folder + count).
export default function MaterialCard({ m, folder, count = 0, to, onClick, index = 0 }) {
  const isFolder = !!folder;
  const item = isFolder ? folder : m;
  const Comp = isFolder && !to ? "button" : Link;
  const linkProps = Comp === Link ? { to: to || `/materiali/${m.id}` } : { type: "button", onClick };
  return (
    <Comp
      {...linkProps}
      className="maven-card group relative block h-full min-h-[118px] w-full p-3 sm:min-h-[126px] text-left sm:p-4"
      data-testid={isFolder ? `folder-item-card-${index}` : `material-item-card-${index}`}
      data-folder-id={isFolder ? folder.id : undefined}
    >
      {!isFolder && (
        <div className="absolute right-2 top-2">
          <FavoriteButton kind="material" id={m.id} />
        </div>
      )}
      <div className="flex items-start justify-between gap-2 pr-10">
        <div className="min-w-0 flex-1">
          <div className="mb-1 flex flex-wrap items-center gap-1.5">
            {isFolder ? (
              <span className="inline-flex items-center gap-1 text-[10px] font-bold uppercase tracking-wider text-[#0153A3]" data-testid={`folder-count-${folder.id}`}>
                <Files size={14} /> {count} {count === 1 ? "materiale" : "materiali"}
              </span>
            ) : (
              <>
                <FileBadge type={m.file_type} />
                {m.type_name && (
                  <span className="text-[10px] font-bold uppercase tracking-wider text-[#0153A3]">{m.type_name}</span>
                )}
              </>
            )}
          </div>
          <div className="text-sm font-semibold text-[#1F2937] sm:text-base line-clamp-2">
            {isFolder ? folder.name : m.title}
          </div>
          {!isFolder && m.product_name && (
            <div className="mt-0.5 text-xs text-[#6B7280] truncate">{m.product_name}</div>
          )}
          {!isFolder && m.description && (
            <p className="mt-1.5 text-xs text-[#6B7280] line-clamp-2">{m.description}</p>
          )}
          <div className="mt-2 text-[11px] text-[#9CA3AF]">Agg. {formatDate(item.updated_at || item.created_at)}</div>
        </div>
        {!isFolder && m.important && (
          <div className="flex h-7 w-7 flex-none items-center justify-center rounded-full bg-[#EFF6FF] text-[#0153A3]" title="Importante">
            <Star size={14} fill="currentColor" />
          </div>
        )}
      </div>
    </Comp>
  );
}
